import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { AdminLayout } from "@/components/admin/AdminLayout";
import { RequireAdminAuth } from "@/components/admin/RequireAdminAuth";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { seoRoutes } from "@/config/seo.config";
import { AdminDashboardPage } from "@/pages/admin/AdminDashboardPage";
import { AdminLoginPage } from "@/pages/admin/AdminLoginPage";
import { AdminSettingsPage } from "@/pages/admin/AdminSettingsPage";
import { AdminWaitlistPage } from "@/pages/admin/AdminWaitlistPage";
import { HomePage } from "@/pages/HomePage";
import { LandingPage } from "@/pages/LandingPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { PrivacyPage } from "@/pages/PrivacyPage";
import { RegisterPage } from "@/pages/RegisterPage";
import { TermsPage } from "@/pages/TermsPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="admin/login" element={<AdminLoginPage />} />
        <Route element={<RequireAdminAuth />}>
          <Route path="admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboardPage />} />
            <Route path="waitlist" element={<AdminWaitlistPage />} />
            <Route path="settings" element={<AdminSettingsPage />} />
          </Route>
        </Route>

        <Route element={<SiteLayout />}>
          <Route index element={<HomePage />} />
          {seoRoutes.map((route) => (
            <Route
              key={route.path}
              path={route.path.slice(1)}
              element={<LandingPage />}
            />
          ))}
          <Route path="register" element={<RegisterPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}
